import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Table, Row, Col } from 'antd'
import { users } from '@services/api'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class List extends Component<any> {
    handlePopup = async id => {
        try {
            const user = await users.getUser({ user_id: id })
            this.props.popupStore.togglePopup('editUser', user.data[0])
            
        } catch (error) {
            alert('Permition denied!')
        }
    }

    render() {
        const { roles } = this.props.authStore

        const { list, loading } = this.props
        let newList: object[]
        //if current admin panel user role is "moderator" or "editor" or "viewer" do filter on data view
        if (roles.includes('moderator') || roles.includes('editor') || roles.includes('viewer')) {
            newList = list.filter(obj => obj.role !== 'מנהל')
        }
        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם משתמש',
                key: 'username',
                render: (_, record) => <span>{record.username}</span>
            },
            {
                title: 'כתובת מייל',
                key: 'email',
                render: (_, record) => <span>{record.email}</span>
            },
            {
                title: 'הרשאה',
                key: 'role',
                render: (_, record) => <span>{record.role}</span>
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            columns={columns}
                            rowClassName={() => style.user_row}
                            dataSource={newList ? newList : list}
                            pagination={{
                                pageSize: 10
                            }}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        this.handlePopup(record.id)
                                    }
                                }
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}
